import React, { useEffect, useState, useCallback } from "react";
import {
  Divider,
  Tooltip,
  Typography,
  IconButton,
  Badge,
  Grid,
  Box,
} from "@material-ui/core";
import Modal from "../../cm_shared/cm_global_modal";
import axios from "axios";
import DataTable from "react-data-table-component";
import { NoteAdd as NoteAddIcon } from "@material-ui/icons";
import ScenarioGroupingFlow from "../ScenarioGroupingFlow";
import options from "./options";
import CustomPagination from "../../cm_shared/CMCustomPagination";
import { Link } from "react-router-dom";
import CMDeleteModal from "../../cm_shared/CMDeleteModal";
import PGScenarioLogicalNameListing from '../OpenLoopListing/PGScenariosLogicalBased/index'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip as ChartTooltip, Legend, ResponsiveContainer } from 'recharts';

const parseJSONString = (str) => {
  try {
    return JSON.parse(str.replace(/'/g, '"'));
  } catch (error) {
    return str;
  }
};

const customStyles = {
  table: {
    style: {
      border: "solid 1px rgba(0,0,0,.2)",
      borderRadius: "10px",
    },
  },
  rows: {
    style: {
      minHeight: "72px",
      cursor: "pointer",
      fontSize: 16,
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      backgroundColor: "#b0ff45",
      justifyContent: "center",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "center",
    },
  },
};

function PRDataSubtableResimulationHistory(props) {
  console.log("PRDataSubtableResimulationHistory", props.match.params.id)
  const [loading, setLoading] = useState(false);
  const [scenarioCollectionNew, setScenarioCollectionNew] = useState([]);
  const [graphData, setGraphData] = useState([]);
  const initialColumns = [
    {
      name: "Sim. Data",
      selector: "sim_date",
      sortable: false,
      reorder: false,
    },
    {
      name: "CMBS SW Version",
      selector: "cmbs_sw_version",
      sortable: false,
      reorder: false,
    },
    {
      name: "CMBS activation",
      selector: "cmbs_activation",
      sortable: false,
      reorder: false,
    },
    {
      name: "Report Link",
      selector: "report_link",
      sortable: false,
      reorder: false,
    }
  ];

  const trimDataTaggingColumn = [
    {
      name: "Category",
      selector: "sim_date",
      sortable: false,
      reorder: false,
    },
    {
      name: "Hypo class",
      selector: "cmbs_sw_version",
      sortable: false,
      reorder: false,
    },
    {
      name: "Hypo type",
      selector: "cmbs_activation",
      sortable: false,
      reorder: false,
    },
    {
      name: "Senson Resim necessary",
      selector: "report_link",
      sortable: false,
      reorder: false,
    }
  ]


  const fetchScenarioCollectionNew = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `http://localhost:3010/resimulation_history`,
      );
      console.log('resimulationHistory', response);
      setScenarioCollectionNew(response.data);

      const chartResponse = await axios.get(
        `http://localhost:3010/vehicle_information_line_chart_data`,
      );
      console.log('chartResponse', chartResponse);
      setGraphData(chartResponse.data);

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchScenarioCollectionNew()
  }, [])

  const handleRowClick = (row, e) => {
    console.log("row E", row, e);
  }

  return (
    <div
      style={{
        padding: "1rem",
        position: "relative",
        background: "white",
        margin: "30px"
      }}
    >
      <Grid container>
        <Grid item xs={8}>
          <Grid 
          spacing={3}
          style={{
          fontWeight: 400,
          fontSize: "16px",
          backgroundColor: "white",
          border: "solid 1px rgba(0,0,0,.2)",
          borderRadius: "10px",
          padding: "20px",
          margin: "43px 0px 70px",
          gap: "30px",
          textAlign: "center"
          }}
          >
            <Grid item xs={12}>
              <Typography variant="h4">Data Segment Details</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h5"> ( 0002 , 2024/08/01 , CAT1-5 ) </Typography>
            </Grid>
          </Grid>


          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <Typography variant="h4">Re-simulation History</Typography>
            <div style={{ overflowX: "auto" }}>
              {loading === false && initialColumns.length > 0 ? (
                <DataTable
                  columns={initialColumns}
                  data={scenarioCollectionNew}
                  customStyles={customStyles}
                  progressPending={loading}
                  loading={loading}
                  onRowClicked={handleRowClick}
                ></DataTable>
              ) : null}
            </div>
          </div>
        </Grid>
        <Grid item xs={4}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", padding: "40px", paddingRight:"0px"}}>
            <Box sx={{ display: "grid", gridTemplateColumns: "47% auto 47%" }}>
              <Box style={{
                border: "1px solid rgba(0,0,0,.2)",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "16px",
                backgroundColor: "#f9f9f9",
                height: "200px"
              }}>Video Front</Box>
              <Box />
              <Box style={{
                border: "1px solid rgba(0,0,0,.2)",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "16px",
                backgroundColor: "#f9f9f9",
                height: "100%"
              }}>Video Right</Box>
            </Box>
            <Box sx={{ display: "grid", gridTemplateColumns: "47% auto 47%" }}>
              <Box style={{
                border: "1px solid rgba(0,0,0,.2)",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "16px",
                backgroundColor: "#f9f9f9",
                height: "200px",
              }}>Video Rear</Box>
              <Box />
              <Box style={{
                border: "1px solid rgba(0,0,0,.2)",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "16px",
                backgroundColor: "#f9f9f9",
                height: "100%"
              }}>Video Left</Box>
            </Box>
            <Box style={{
              border: "1px solid rgba(0,0,0,.2)",
              borderRadius: "10px",
              padding: "10px"
            }}>

              <LineChart
                width={450}
                height={300}
                data={graphData}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >

                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <ChartTooltip />
                <Legend />
                <Line type="monotone" dataKey="yaw_rate" stroke="#8884d8" activeDot={{ r: 8 }} />
                <Line type="monotone" dataKey="steer_angle" stroke="#ff0000" />
                <Line type="monotone" dataKey="brake_pedal_operation" stroke="#ccc" />
                <Line type="monotone" dataKey="acceleration_operation" stroke="#82ca9d" />
              </LineChart>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Grid>
        <Grid item xs={12}>
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <Typography variant="h4">Trim Data tagging
                <Typography style={{textDecoration: "underline", padding:"5px"}} display="inline">tags editing history</Typography>
            </Typography>
            
            <div style={{ overflowX: "auto" }}>
              {loading === false && trimDataTaggingColumn.length > 0 ? (
                <DataTable
                  columns={trimDataTaggingColumn}
                  data={scenarioCollectionNew}
                  customStyles={customStyles}
                  progressPending={loading}
                  loading={loading}
                  onRowClicked={handleRowClick}
                ></DataTable>
              ) : null}
            </div>
          </div>
        </Grid>
      </Grid>

    </div>
  );
}

export default PRDataSubtableResimulationHistory;
